var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.okToShow,
          expression: "okToShow",
        },
      ],
      ref: "container",
    },
    [
      _c(
        "pre",
        {
          class: [
            `margin-0 ${_vm.hlClass}`,
            { "terminal-line-start": _vm.lang === "bash" },
          ],
          staticStyle: {
            "background-color": "inherit",
            "--code-font-size": "var(--font-size-md)",
          },
          on: { mouseup: _vm.onMouseUp },
        },
        [_c("code", { ref: "hl" })]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }